export const TRACKER_CREATE_TABLE_CLICK = '[Mapper] schema builder create table button clicked';
export const TRACKER_CANCEL_CLICK = '[Mapper] schema builder cancel button clicked';
export const TRACKER_TABLE_TYPE_SELECT_BUTTON_CLICK =
  '[Firebolt] schema builder selelct table type button clicked';
export const TRACKER_TABLE_TYPE_DROPDOWN_CLICK =
  '[Firebolt] schema builder table type dropdown clicked';
export const TRACKER_FIELDS_INFO_TOOL_CLICK = '[Firebolt] schema builder field info tool toggled';
export const TRACKER_WARNING_DIALOG_CREATE_TABLE_CLICK =
  '[Firebolt] warning dialog create table button clicked';
export const TRACKER_FIREBOLT_INDEXING_DOC_LINK_CLICK =
  '[Firebolt] firebolt indexing docs link click';
